import * as FontsClient from 'ContentData/api/Fonts';
import * as FilemanagerClient from 'ContentData/api/Filemanager';
import { createGenericCreateAction, createGenericFetchAction } from 'ContentData/helpers/reduxHelpers';
import { CUSTOM_FONTS_BY_ASSET_FETCH_FONTS, CUSTOM_FONTS_CLEAR_UPDATE_STATUS, CUSTOM_FONTS_CREATE_FONT, CUSTOM_FONTS_DELETE_FONT, CUSTOM_FONTS_EDIT_FONT, CUSTOM_FONTS_FETCH_FILE, CUSTOM_FONTS_FETCH_FONT, CUSTOM_FONTS_FETCH_FONTS, CUSTOM_FONTS_FILE_UPLOAD, GOOGLE_FONTS_CLEAR, GOOGLE_FONTS_FETCH_COMMON_FONTS, GOOGLE_FONTS_FETCH_FONT, GOOGLE_FONTS_FETCH_FONTS, SELECT_CUSTOM_FONT, SELECT_GOOGLE_FONT, BRAND_FONTS_FETCH_FONTS } from 'ContentData/actions/ActionTypes';
const fetchGoogleFontsAction = createGenericFetchAction(GOOGLE_FONTS_FETCH_FONTS, FontsClient.fetch);
const fetchFontAction = createGenericFetchAction(GOOGLE_FONTS_FETCH_FONT, FontsClient.fetchFont);
const fetchCommonFontsAction = createGenericFetchAction(GOOGLE_FONTS_FETCH_COMMON_FONTS, FontsClient.fetch);
const fetchCustomFontsAction = createGenericFetchAction(CUSTOM_FONTS_FETCH_FONTS, FontsClient.fetchCustomFonts);
const fetchCustomFontsByAssetAction = createGenericFetchAction(CUSTOM_FONTS_BY_ASSET_FETCH_FONTS, FontsClient.fetchCustomFontsByAsset);
const fetchCustomFontByAssetAction = createGenericFetchAction(CUSTOM_FONTS_BY_ASSET_FETCH_FONTS, FontsClient.fetchCustomFontsByAsset);
const fetchCustomFontAction = createGenericFetchAction(CUSTOM_FONTS_FETCH_FONT, FontsClient.fetchCustomFont);
const createCustomFontAction = createGenericCreateAction(CUSTOM_FONTS_CREATE_FONT, FontsClient.createCustomFont);
const fetchBrandFontsAction = createGenericFetchAction(BRAND_FONTS_FETCH_FONTS, FontsClient.fetchBrandFonts);
export const fetchGoogleFonts = query => fetchGoogleFontsAction(query);
export const fetchFont = name => fetchFontAction(name);
export const fetchCommonFonts = query => fetchCommonFontsAction(query);
export const clearFonts = () => ({
  type: GOOGLE_FONTS_CLEAR
});
export const selectFont = font => ({
  type: SELECT_GOOGLE_FONT,
  font
});
export const selectCustomFont = font => ({
  type: SELECT_CUSTOM_FONT,
  font
});
export const fetchCustomFonts = params => fetchCustomFontsAction(params || {});
export const fetchCustomFontsByAsset = query => fetchCustomFontsByAssetAction(query);
export const fetchCustomFontByAsset = query => fetchCustomFontByAssetAction(query);
export const fetchCustomFont = id => fetchCustomFontAction(id);
export const createCustomFont = data => createCustomFontAction(data);
export const editCustomFont = data => {
  return dispatch => {
    dispatch({
      type: CUSTOM_FONTS_EDIT_FONT,
      data
    });
    return FontsClient.editCustomFont(data).then(response => {
      dispatch({
        type: CUSTOM_FONTS_EDIT_FONT,
        response
      });
    }).catch(error => {
      dispatch({
        type: CUSTOM_FONTS_EDIT_FONT,
        error
      });
    });
  };
};
export const uploadCustomFontFile = (data, fileName) => {
  return dispatch => {
    dispatch({
      type: CUSTOM_FONTS_FILE_UPLOAD,
      fileName
    });
    return FilemanagerClient.uploadFile(data).then(response => {
      dispatch({
        type: CUSTOM_FONTS_FILE_UPLOAD,
        response,
        fileName
      });
    }).catch(error => {
      dispatch({
        type: CUSTOM_FONTS_FILE_UPLOAD,
        error,
        fileName
      });
    });
  };
};
export const fetchCustomFontFile = (id, fileName) => {
  return dispatch => {
    dispatch({
      type: CUSTOM_FONTS_FETCH_FILE,
      id,
      fileName
    });
    return FilemanagerClient.fetchFile(id).then(response => {
      dispatch({
        type: CUSTOM_FONTS_FETCH_FILE,
        response,
        id,
        fileName
      });
    }).catch(error => {
      dispatch({
        type: CUSTOM_FONTS_FETCH_FILE,
        error,
        id,
        fileName
      });
    });
  };
};
export const deleteCustomFont = id => {
  return dispatch => {
    dispatch({
      type: CUSTOM_FONTS_DELETE_FONT,
      id
    });
    return FontsClient.deleteCustomFont(id).then(response => {
      dispatch({
        type: CUSTOM_FONTS_DELETE_FONT,
        response,
        id
      });
    }).catch(error => {
      dispatch({
        type: CUSTOM_FONTS_DELETE_FONT,
        error,
        id
      });
    });
  };
};
export const clearUpdateRequestStatuses = () => {
  return dispatch => {
    dispatch({
      type: CUSTOM_FONTS_CLEAR_UPDATE_STATUS
    });
  };
};
export const fetchBrandFonts = brandKitId => fetchBrandFontsAction(brandKitId);